import { createContext } from 'react';
export const RouteContext = /*#__PURE__*/createContext({
  match: null,
  routes: [],
  params: {}
});